import { render } from "./complianceOpinion.vue?vue&type=template&id=1509c90e&scoped=true"
import script from "./complianceOpinion.vue?vue&type=script&lang=js"
export * from "./complianceOpinion.vue?vue&type=script&lang=js"

import "./complianceOpinion.vue?vue&type=style&index=0&id=1509c90e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1509c90e"]])

export default __exports__